module.exports = __webpack_public_path__ + "img/ic_chevron_solid.a653704d.svg";